import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { persistStore } from "redux-persist"
import store from '../src/redux/store'
import { Provider } from 'react-redux'
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById('root'));
let persistor = persistStore(store)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

